import React from 'react';

/**
 * Global error boundary — catches any unhandled React render error
 * and shows a recovery screen instead of a blank white page.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Surface details in the console so we can debug from logs
    console.error('[ErrorBoundary] Caught render error:', error, errorInfo);
  }

  handleReload = () => {
    try { window.location.reload(); } catch (e) { /* noop */ }
  };

  handleClearCache = async () => {
    try {
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      }
    } catch (e) { /* noop */ }
    try { window.location.reload(); } catch (e) { /* noop */ }
  };

  render() {
    if (this.state.hasError) {
      const msg = (this.state.error && (this.state.error.message || String(this.state.error))) || 'Bilinmeyen hata';
      return (
        <div style={{ minHeight: '100vh', background: '#1c1917', color: '#fafaf9', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
          <div style={{ maxWidth: '480px', textAlign: 'center' }} data-testid="error-boundary-screen">
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>⚠️</div>
            <h1 style={{ fontSize: '22px', fontWeight: 700, marginBottom: '8px' }}>Bir hata oluştu</h1>
            <p style={{ fontSize: '14px', color: '#a8a29e', marginBottom: '24px' }}>
              Sayfa yüklenirken beklenmedik bir hata oluştu. Aşağıdaki düğmelerle devam edebilirsiniz.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <button onClick={this.handleReload} data-testid="error-reload-btn"
                style={{ background: '#BC5229', color: '#fff', padding: '12px 24px', borderRadius: '12px', border: 'none', fontWeight: 700, fontSize: '15px', cursor: 'pointer' }}>
                Sayfayı Yenile
              </button>
              <button onClick={this.handleClearCache} data-testid="error-clear-cache-btn"
                style={{ background: 'transparent', color: '#fafaf9', padding: '10px 24px', borderRadius: '12px', border: '1px solid #57534e', fontWeight: 600, fontSize: '13px', cursor: 'pointer' }}>
                Önbelleği Temizle ve Yenile
              </button>
            </div>
            <details style={{ marginTop: '20px', textAlign: 'left', fontSize: '11px', color: '#78716c' }}>
              <summary style={{ cursor: 'pointer' }}>Teknik detay</summary>
              <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', marginTop: '8px', padding: '8px', background: '#0c0a09', borderRadius: '6px' }}>{msg}</pre>
            </details>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
